<div class="confirmation-dialog">
  <div class="flex items-center">
    <div class="mr-3">
      <ic-icon [icon]="icWarning" class="text-amber-500" size="24px"></ic-icon>
    </div>
    <h2 mat-dialog-title class="headline m-0 pr-6 flex-auto">Confirmation de remplacement du contact Commande</h2>
    <button class="text-secondary" mat-dialog-close type="button" mat-icon-button>
      <ic-icon [icon]="icClose"></ic-icon>
    </button>
  </div>

  <mat-dialog-content class="content">
    <div class="mb-6">
      <p class="text-secondary text-base mb-4">
        Un ou plusieurs contacts de type
        <strong>Commande</strong>
        existent déjà pour ce fournisseur. Souhaitez-vous les remplacer par le nouveau contact ?
      </p>
    </div>

    <!-- Nouveau contact -->
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <h3 class="text-lg font-semibold text-blue-800 mb-3 flex items-center">
        <ic-icon [icon]="icPeople" class="mr-2" size="20px"></ic-icon>
        Nouveau contact
      </h3>
      <div class="grid grid-cols-1 gap-2 text-sm">
        <div>
          <strong>Nom :</strong>
          {{ getContactFullName(data.newContact) }}
        </div>
        <div>
          <strong>Email :</strong>
          {{ data.newContact.email }}
        </div>
        <div>
          <strong>Téléphone :</strong>
          {{ formatPhoneNumbers(data.newContact.phoneNumbers) }}
        </div>
      </div>
    </div>

    <!-- Contacts existants concernés -->
    <div class="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
      <h3 class="text-lg font-semibold text-orange-800 mb-4 flex items-center">
        <ic-icon [icon]="icPeople" class="mr-2" size="20px"></ic-icon>
        Contacts existants qui seront remplacés
      </h3>

      <div class="space-y-4">
        <div
          *ngFor="let contact of data.conflictingContacts; let i = index"
          class="border border-orange-300 rounded-lg p-3 bg-white"
        >
          <!-- Informations du contact -->
          <div class="mb-3">
            <h4 class="font-semibold text-base text-gray-800 flex items-center">
              📞 Contact {{ i + 1 }} : {{ getContactFullName(contact) }}
            </h4>
            <div class="text-sm text-gray-600 mt-1">
              <div>
                <strong>Email :</strong>
                {{ contact.email }}
              </div>
              <div>
                <strong>Téléphone :</strong>
                {{ formatPhoneNumbers(contact.phoneNumbers) }}
              </div>
            </div>
          </div>

          <!-- Établissements concernés -->
          <div class="ml-4">
            <p class="text-sm font-medium text-gray-700 mb-2 flex items-center">
              <ic-icon [icon]="icBusiness" class="mr-1" size="16px"></ic-icon>
              → Établissements concernés :
            </p>
            <ul class="list-disc list-inside text-sm text-gray-600 ml-4 space-y-1">
              <li *ngFor="let establishment of contact.establishments">• {{ establishment.label }}</li>
            </ul>
            <p class="text-xs text-orange-600 mt-2 font-medium">
              → {{ contact.totalEstablishments }} établissement{{
                contact.totalEstablishments > 1 ? 's' : ''
              }}
              impacté{{ contact.totalEstablishments > 1 ? 's' : '' }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Récapitulatif -->
    <div class="bg-gray-100 border border-gray-300 rounded-lg p-4">
      <h3 class="text-lg font-semibold text-gray-800 mb-2">Récapitulatif total</h3>
      <div class="text-sm space-y-1">
        <div>
          <span class="font-medium">{{ data.summary.totalEstablishmentsImpacted }}</span>
          établissement{{ data.summary.totalEstablishmentsImpacted > 1 ? 's' : '' }} concerné{{
            data.summary.totalEstablishmentsImpacted > 1 ? 's' : ''
          }}
        </div>
        <div>
          <span class="font-medium">{{ data.summary.totalContactsToReplace }}</span>
          contact{{ data.summary.totalContactsToReplace > 1 ? 's' : '' }} remplacé{{
            data.summary.totalContactsToReplace > 1 ? 's' : ''
          }}
        </div>
      </div>
    </div>

    <div class="mt-6 text-sm text-gray-600">
      <p>
        <strong>Note :</strong>
        Les contacts existants perdront le type "Commande" uniquement pour les établissements concernés. Si un contact
        n'a plus d'établissement associé après cette opération, le type "Commande" lui sera complètement retiré.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <button mat-button type="button" (click)="onCancel()" class="mr-4">Annuler</button>
    <button mat-flat-button color="warn" type="button" (click)="onConfirm()">Remplacer tous</button>
  </mat-dialog-actions>
</div>
